import { LoginConfig, AppConfig } from 'app/core/model/trjireh-model';
import { Injectable } from '@angular/core';
import {JsonApiService} from './json-api.service';

@Injectable()
export class ConfigService {

  url = '/config/config.json';

  private loginConfig = new LoginConfig();
  private appConfig = new AppConfig();
  private isLoaded = false;

  constructor(private jsonApiService: JsonApiService) {

  }

  loadConfig()
  {
    this.isLoaded = false;
    this.getConfig().subscribe(c => {
      const login = c.filter((a: { name: string; }) => a.name == 'login');
      if (login.length > 0){
        this.loginConfig = login[0].data;
      }

      const app = c.filter((a: { name: string; }) => a.name == 'app');
      if (app.length > 0){
        this.appConfig = app[0].data;
        this.isLoaded = true;
      }
    });
  }

  getAppConfig() {
    if (!this.isLoaded){
      this.loadConfig();
    }
    return this.appConfig;
  }

  getLoginConfig() {
    return this.loginConfig;
  }

  public getConfig()  {
    return this.jsonApiService.fetch(this.url)
  }

}



// WEBPACK FOOTER //
// C:/Users/stivens/Lab/sonever/repos/taller-web/src/app/core/api/config.service.ts